import { toasts } from "svelte-toasts";
import AppConfig from "../../app.config";
import Session from "./Session";
export default class Product {
    static async get() {
        const res = await fetch(`${AppConfig.REST.URL}/product/`);
        const json = await res.json();
        return json;
    }
    static async add(name, discount, price) {
        const token = Session.getToken();
        const body = new URLSearchParams();
        body.append('name', name);
        body.append('discount', discount);
        body.append('price', price);
        const res = await fetch(`${AppConfig.REST.URL}/product/?token=${token}`, { method: 'POST', body });
        const json = await res.json();
        if (res.status == 201)
            toasts.success(`Sukces`, `Nowy produkt został właśnie utworzony!`);
        else if (res.status == 500)
            toasts.error(`Uwaga`, `Sprawdź pola formularza i spróbuj ponownie.`);
        return json;
    }
    static async update(product, field) {
        const token = Session.getToken();
        const body = new URLSearchParams();
        body.append(field.name, field.value);
        const res = await fetch(`${AppConfig.REST.URL}/product/${product}?token=${token}`, { method: 'PUT', body });
        const json = await res.json();
        if (res.status == 200)
            toasts.success(`Sukces`, `Zmodyfikowany produkt został pomyślnie zapisany.`);
        return json;
    }
    static async remove(product) {
        const token = Session.getToken();
        const res = await fetch(`${AppConfig.REST.URL}/product/${product}?token=${token}`, { method: 'DELETE' });
        if (res.status == 204)
            toasts.success(`Sukces`, `Produkt został usunięty.`);
        return res ? true : false;
    }
}
